import { render } from "./RenderPDF.vue?vue&type=template&id=30b0c924&scoped=true"
import script from "./RenderPDF.vue?vue&type=script&lang=js"
export * from "./RenderPDF.vue?vue&type=script&lang=js"

import "./RenderPDF.vue?vue&type=style&index=0&id=30b0c924&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b0c924"]])

export default __exports__